export default __webpack_public_path__ + "static/media/jzds_01.fb80712d.png";